/**
 * Gallera Chat PWA — helper de URL (só para exibição no painel).
 *
 * A fonte da verdade é o backend:
 *  - o link de convite de um contato vem de POST /webchat/invite → { url }
 *  - a base do app da empresa vem de GET /webchat/uuid → { pwaUrl }
 *
 * Este helper é apenas o plano B, caso o backend ainda não devolva `pwaUrl`
 * (servidor mais antigo). Espelha exatamente a regra de
 * `backend/src/helpers/webchatInviteToken.ts` → `webchatPwaBaseUrl()`:
 *   WEBCHAT_PWA_URL  ||  FRONTEND_URL + "/chat"
 * No frontend, `FRONTEND_URL` é a própria origem onde o painel está aberto.
 */
const readEnv = (name) => {
  if (typeof window !== "undefined" && window.ENV !== undefined) {
    return window.ENV[name] || null;
  }
  return process.env[name] || null;
};

const stripTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

export function getWebChatPwaBaseUrl() {
  const configured = readEnv("REACT_APP_WEBCHAT_PWA_URL");
  if (configured) {
    return stripTrailingSlash(configured);
  }

  const origin =
    typeof window !== "undefined" && window.location
      ? stripTrailingSlash(window.location.origin)
      : "";

  return origin ? `${origin}/chat` : "";
}

export default getWebChatPwaBaseUrl;
